import $ from "jquery";
import _ from "lodash";
import { subscribe } from "../events/jQuerySubscription";
class Draggable {
    constructor({ positionMode, draggable, clientX, clientY }) {
        this.draggable = draggable;
        this.positionMode = positionMode;
        this.clientX = clientX;
        this.clientY = clientY;
        const offset = $(this.draggable).offset();
        this.offsetX = clientX - offset.left;
        this.offsetY = clientY - offset.top;
    }
    startDragging(clientX, clientY) {
        if (this.positionMode === "relative") {
            const offset = $(this.draggable).offset();
            const offsetX = clientX - offset.left;
            const offsetY = clientY - offset.top;
            this.clientX = this.clientX - (this.offsetX - offsetX);
            this.clientY = this.clientY - (this.offsetY - offsetY);
            this.offsetX = offsetX;
            this.offsetY = offsetY;
        }
        else {
            this.clientX = clientX;
            this.clientY = clientY;
        }
        this.mouseMoveSubscription = subscribe($(document), "mousemove", (e) => this.drag(e));
        this.mouseUpSubscription = subscribe($(document), "mouseup", () => this.stopDragging());
    }
    drag(e) {
        e.preventDefault();
        const draggable = $(this.draggable);
        const position = this.positionMode === "absolute"
            ? draggable.position()
            : {
                top: 0,
                left: 0,
            };
        const xShift = this.clientX - e.clientX;
        const yShift = this.clientY - e.clientY;
        if (this.positionMode === "absolute") {
            this.clientX = e.clientX;
            this.clientY = e.clientY;
        }
        draggable.css({
            top: `${position.top - yShift}px`,
            left: `${position.left - xShift}px`,
        });
    }
    stopDragging() {
        var _a, _b;
        (_a = this.mouseUpSubscription) === null || _a === void 0 ? void 0 : _a.off();
        (_b = this.mouseMoveSubscription) === null || _b === void 0 ? void 0 : _b.off();
    }
}
const initialize = (e) => {
    if (mouseIsInsideExcluded(e))
        return;
    e.preventDefault();
    const draggable = $(e.target).closest("[data-draggable]");
    const draggableModel = draggable.data("draggable-model") ||
        new Draggable({
            positionMode: draggable.data("draggable-position-mode") || "relative",
            draggable: draggable[0],
            clientX: e.clientX,
            clientY: e.clientY,
        });
    draggableModel.startDragging(e.clientX, e.clientY);
    draggable.data("draggable-model", draggableModel);
};
const mouseIsInsideExcluded = (e) => _.some($(e.target).closest("[data-draggable-exclude]"));
$(document).on("mousedown", ".draggable-handle", initialize);
